import React from 'react'

import RefundEntry from 'components_v2/Admin/Refund/RefundEntry'

const RefundGiftCardWrapper = (props) => <RefundEntry {...props} />

export default RefundGiftCardWrapper
